<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true">
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新增品牌</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-table :data="brands" highlight-current-row border stripe v-loading="listLoading"
                  @selection-change="selsChange"
                  style="width: 100%;text-align: center">
            <el-table-column type="index" width="100">
            </el-table-column>
            <el-table-column prop="brandName" label="品牌名称">
            </el-table-column>

            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="addCarType(scope.$index, scope.row)">型号管理
                    </el-button>
                    <el-button type="primary" size="small" @click="edit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="del(scope.$index, scope.row)">删除</el-button>

                </template>
            </el-table-column>
        </el-table>

        <!--编辑界面-->
        <el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="120px" ref="editForm">
                <el-form-item label="品牌名称" class="require" prop="brandName">
                    <el-input v-model="editForm.brandName" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增品牌-->
        <el-dialog title="新增品牌" v-model="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="120px" ref="addForm">

                <el-form-item label="品牌名称" class="require" prop="brandName">
                    <el-input v-model="addForm.brandName" auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>


        <!--型号管理-->
        <el-dialog title="车辆信号" v-model="carTypeVisible" :close-on-click-modal="false">
            <el-form :inline="true">
                <el-form-item>
                    <el-button type="primary" @click="addCarTypeDialog">新增型号</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="carTypes" highlight-current-row border stripe
                      @selection-change="selsChange"
                      style="width: 100%;text-align: center">

                <el-table-column type="index" width="100">
                </el-table-column>
                <el-table-column prop="carTypeName" label="型号名称">
                </el-table-column>
                <el-table-column prop="grade" label="等级" :formatter="formatGrade">
                </el-table-column>

                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="editCarType(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button type="danger" size="small" @click="delCarType(scope.$index, scope.row)">删除
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <!--新增型号-->
        <el-dialog title="新增车辆型号" v-model="addCarTypeVisible" :close-on-click-modal="false">
            <el-form :model="carTypeForm" label-width="120px" ref="carTypeForm">

                <el-form-item label="型号名称" class="require" prop="carTypeName">
                    <el-input v-model="carTypeForm.carTypeName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="档次" class="require" prop="grade">
                    <el-radio-group v-model="carTypeForm.grade">

                        <el-radio class="radio" :label="1">高档车型</el-radio>
                        <el-radio class="radio" :label="0">普通车型</el-radio>
                    </el-radio-group>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addCarTypeVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addCarTypeSubmit">提交</el-button>
            </div>
        </el-dialog>

        <!--编辑型号-->
        <el-dialog title="新增车辆型号" v-model="editCarTypeVisible" :close-on-click-modal="false">
            <el-form :model="editCarTypeForm" label-width="120px" ref="editCarTypeForm">

                <el-form-item label="型号名称" class="require" prop="carTypeName">
                    <el-input v-model="editCarTypeForm.carTypeName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="档次" class="require" prop="grade">
                    <el-radio-group v-model="editCarTypeForm.grade">

                        <el-radio class="radio" :label="1">高档车型</el-radio>
                        <el-radio class="radio" :label="0">普通车型</el-radio>
                    </el-radio-group>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editCarTypeVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editCarTypeSubmit">提交</el-button>
            </div>
        </el-dialog>


    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {
        data() {
            return {

                brands: [],
                carTypes: [],
                total: 0,
                rowCount: 20,
                pageNO: 1,
                listLoading: false,
                sels: [],

                editFormVisible: false,
                editLoading: false,
                editForm: {
                    carBrandId: '',
                    brandName: ''

                },

                addFormVisible: false,
                addLoading: false,
                addForm: {
                    brandName: ''
                },
                carTypeVisible: false,
                carTypeForm: {
                    carBrandId: '',
                    carTypeName: '',
                    grade: 0,
                },
                addCarTypeVisible: false,
                editCarTypeVisible: false,
                editCarTypeForm: {
                    carTypeId: '',
                    carTypeName: '',
                    grade: ''
                },


            }
        },
        methods: {
            formatGrade(row, column) {
                if (row.grade == 1) {
                    return '高档车型'
                } else if (row.grade == 0)
                    return '普通车型'
            },

            handleCurrentChange(val) {
                this.pageNO = val;
                this.getbrands();
            },

            getbrands() {

                this.listLoading = true;
                NProgress.start();
                let url = 'carBrand/getAll.do';
                requestPost(this, url, {}).then((res) => {

                    if (res != '') {
                        this.brands = res.data;
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },
            //删除
            del: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    NProgress.start();
                    let para = {carBrandId: row.carBrandId};
                    let url = 'carBrand/del.do';
                    requestPost(this, url, para).then((res) => {
                        this.listLoading = false;
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.getbrands();
                        }
                    });
                }).catch(() => {

                });
            },
            delCarType: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {

                    NProgress.start();
                    let para = {carTypeId: row.carTypeId};
                    let url = 'carType/del.do';
                    requestPost(this, url, para).then((res) => {
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.getCarType();
                        }
                    });
                }).catch(() => {

                });
            },
            //显示编辑界面
            edit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            //显示新增界面
            handleAdd: function () {
                this.addFormVisible = true;
            },
            addCarTypeDialog() {
                this.addCarTypeVisible = true;
            },
            getCarType() {
                let para = Object.assign({}, this.carTypeForm)

                NProgress.start();
                let url = 'carType/getByCarBrand.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {
                        this.carTypes = res.data;
                    }

                    NProgress.done();
                });
            },
            addCarType(index, row) {
                this.carTypeVisible = true;
                this.carTypeForm.carBrandId = row.carBrandId;
                this.getCarType();
            },
            editCarType(index, row) {
                this.editCarTypeVisible = true;
                this.editCarTypeForm = Object.assign({}, row);

            },
            editCarTypeSubmit() {

                this.$confirm('确认提交吗？', '提示', {}).then(() => {

                    NProgress.start();
                    let para = Object.assign({}, this.editCarTypeForm);
                    let url = 'carType/update.do';
                    requestPost(this, url, para).then((res) => {

                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.$refs['editCarTypeForm'].resetFields();
                            this.editCarTypeVisible = false;
                            this.getCarType();
                        }

                    });
                });
            },

            //编辑
            editSubmit: function () {

                this.$confirm('确认提交吗？', '提示', {}).then(() => {
                    this.editLoading = true;
                    NProgress.start();
                    let para = Object.assign({}, this.editForm);
                    let url = 'carBrand/update.do';
                    requestPost(this, url, para).then((res) => {
                        this.editLoading = false;
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.$refs['editForm'].resetFields();
                            this.editFormVisible = false;
                            this.getbrands();
                        }

                    });
                });

            },

            addSubmit: function () {

                this.$confirm('确认提交吗？', '提示', {}).then(() => {
                    this.addLoading = true;
                    NProgress.start();
                    let para = Object.assign({}, this.addForm);
                    let url = 'carBrand/add.do';
                    requestPost(this, url, para).then((res) => {
                        this.addLoading = false;
                        NProgress.done();
                        if (res !== '') {
                            util.successTip(this);
                            this.$refs['addForm'].resetFields();
                            this.addFormVisible = false;
                            this.getbrands();
                        }
                    });
                });

            },

            addCarTypeSubmit: function () {

                this.$confirm('确认提交吗？', '提示', {}).then(() => {

                    NProgress.start();
                    let para = Object.assign({}, this.carTypeForm);
                    let url = 'carType/add.do';
                    requestPost(this, url, para).then((res) => {

                        NProgress.done();
                        if (res !== '') {
                            util.successTip(this);
                            this.$refs['carTypeForm'].resetFields();
                            this.addCarTypeVisible = false;
                            this.getCarType();
                        }
                    });
                });

            },

            selsChange: function (sels) {
                this.sels = sels;
            }

        },
        activated: function () {

        },
        mounted() {
            this.getbrands();
        }
    }

</script>


<style scope lang="scss" type="text/scss">
    @import '../../styles/vars.scss';
</style>


// WEBPACK FOOTER //
// carManage.vue?5fff5e1c